import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-ice-card',
  templateUrl: './ice-card.component.html',
  styleUrls: ['./ice-card.component.scss'],
  imports: [NgClass],
})
export class IceCardComponent {
  @Input() type: 'regular' | 'error' | 'critical' | 'success' | 'warning' | 'neutral' | 'info' = 'regular';
}
